import { Button, Typography } from "@material-ui/core";
import React from "react";
import { ErrorOutline } from "@material-ui/icons";

export default function FallbackComponent(props) {
  const handleContactSupport = () => {
    window.open("https://support.pocketbits.in/support/tickets/new", "_blank");
  };
  return (
    <div className="container-bt h-screen flex items-center justify-center flex-col  text-center gap-y-10">
      <div>
        <ErrorOutline style={{ fontSize: "40px" }} className="text-red-500" />
        <h1>Oops!</h1>
        <h2>Something went wrong</h2>
      </div>

      <Typography variant="p" className="opacity-80 text-lg">
        We are striving hard to improve your experience.{" "}
        <br className="md:block hidden"></br>Please{" "}
        <strong className="">refresh</strong> the page so that we can attempt to
        fix the issue. <br /> <br />
        If the issue persists even after refresh, please contact support.
      </Typography>

      <div className="flex gap-x-3">
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            window.location.reload(true);
          }}
        >
          Refresh Page
        </Button>
        <Button
          variant="outlined"
          onClick={handleContactSupport}
          color="primary"
        >
          Contact Support
        </Button>{" "}
      </div>
    </div>
  );
}
